import { useSearchParams } from 'react-router-dom'

import { FUNNEL_STAGES, type FunnelStageKey } from '@/api/types'

/** The drill-down's stage: the API's own `drill_down.params.stage`, and the Overview funnel's links. */
const STAGE_PARAM = 'stage'

function isStage(value: string | null): value is FunnelStageKey {
  return value !== null && (FUNNEL_STAGES as readonly string[]).includes(value)
}

/** The stage opened for a closer look, kept in the URL so a link reproduces the view. An unknown value is no stage. */
export function useFunnelStage(): [FunnelStageKey | undefined, (stage: FunnelStageKey | undefined) => void] {
  const [params, setParams] = useSearchParams()
  const raw = params.get(STAGE_PARAM)
  const stage = isStage(raw) ? raw : undefined
  const setStage = (next: FunnelStageKey | undefined) =>
    setParams(
      (current) => {
        const updated = new URLSearchParams(current)
        if (next === undefined) updated.delete(STAGE_PARAM)
        else updated.set(STAGE_PARAM, next)
        return updated
      },
      { replace: true },
    )
  return [stage, setStage]
}
